exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fw-tabs[data-v-ddb7f42c]{display:flex;gap:4px;border-bottom:1px solid #e6e7eb;margin-bottom:16px}.fw-tab[data-v-ddb7f42c]{padding:10px 16px;font-size:13px;font-weight:600;color:#4e5560;text-decoration:none;border-bottom:2px solid transparent}.fw-tab[data-v-ddb7f42c]:focus,.fw-tab[data-v-ddb7f42c]:hover{color:#1d12b9;text-decoration:none}.fw-tab.is-on[data-v-ddb7f42c]{color:#1d12b9;border-bottom-color:#1d12b9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ddb7f42c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/featureWindow/featureWindowTabs.vue
// module id = 1049
// module chunks = 0